<template>
    <div class="drag" ref="dragDiv">
        <div class="drag-box">
            <div class="drag_bg"></div>
        </div>
        <div class="drag_text gray-bg">
            <span :style="{marginLeft: !confirmSuccess ? '60px' : '0px'}">{{confirmWords}}</span>
        </div>
        <div ref="moveDiv" @mousedown="mouseDownFn($event)" @touchstart="touchStartFn($event)" :class="{'el-icon-success':confirmSuccess, 'el-icon-d-arrow-right': !confirmSuccess}" class="handler" style="position: absolute;top: -2px;left: 0;"></div>
    </div>
</template>
<script>
export default {
    props: {
        status: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            beginClientX: 0,
            /*距离屏幕左端距离*/
            mouseMoveState: false,
            /*触发拖动状态  判断*/
            maxWidth: '',
            /*拖动最大宽度，依据滑块宽度算出来的*/
            confirmWords: '按住滑块滑动，拖至最右边',
            /*滑块文字*/
            confirmSuccess: false /*验证成功判断*/
        }
    },
    watch: {
        status: { //深度监听，可监听到对象、数组的变化
            handler(val) {
                console.log(val)
                this.confirmSuccess = val
                if (!val) {
                    this.init()
                }
            },
            deep: true,
            immediate: true,
        }

    },
    methods: {
        //mousedown 事件
        mouseDownFn: function(e) {
            if (!this.confirmSuccess) {
                e.preventDefault && e.preventDefault(); //阻止文字选中等 浏览器默认事件
                this.mouseMoveState = true;
                this.beginClientX = e.clientX;
                this.$emit("mouseDown");
                console.log('电脑端', e)
                if (window.addEventListener) {
                    document.getElementsByTagName('html')[0].addEventListener('mousemove', this.mouseMoveFn);
                    document.getElementsByTagName('html')[0].addEventListener('mouseup', this.moseUpFn);
                    console.log('电脑端', this.mouseMoveState)
                } else {
                    document.getElementsByTagName('html')[0].addEventListener('mouseup', () => {});
                }
            }
        },
        //验证成功函数
        successFunction() {
            this.confirmSuccess = true;
            this.confirmWords = '验证通过';
            if (window.addEventListener) {
                document.getElementsByTagName('html')[0].removeEventListener('mousemove', this.mouseMoveFn);
                document.getElementsByTagName('html')[0].removeEventListener('mouseup', this.moseUpFn);
            } else {
                document.getElementsByTagName('html')[0].removeEventListener('mouseup', () => {});
            }
            document.getElementsByClassName('drag_text')[0].style.color = '#fff';
            document.getElementsByClassName('drag_text')[0].classList.remove("gray-bg");
            document.getElementsByClassName('drag_text')[0].classList.add("red-bg");
            document.getElementsByClassName('handler')[0].style.left = this.maxWidth + 'px';
            document.getElementsByClassName('drag-box')[0].style.width = this.$refs.dragDiv.clientWidth + 'px';
            this.$emit("success", this.confirmSuccess);
        },
        //mousemove事件
        mouseMoveFn(e) {
            console.log('电脑端', this.mouseMoveState)
            if (this.mouseMoveState) {
                let width = e.clientX - this.beginClientX;
                if (width > 0 && width <= this.maxWidth) {
                    document.getElementsByClassName('handler')[0].style.left = width + 'px';
                    document.getElementsByClassName('drag-box')[0].style.width = (width + this.$refs.moveDiv.clientWidth) + 'px';
                    document.getElementsByClassName('drag_text')[0].classList.remove("red-bg");
                    document.getElementsByClassName('drag_text')[0].classList.remove("gray-bg");
                    this.confirmWords = ''
                } else if (width > this.maxWidth) {
                    this.successFunction();
                } else {
                    this.confirmWords = '按住滑块滑动，拖至最右边'
                }
            }
        },
        //mouseup事件
        moseUpFn(e) {
            this.mouseMoveState = false;
            const width = e.clientX - this.beginClientX;
            if (width < this.maxWidth) {
                document.getElementsByClassName('handler')[0].style.left = 0 + 'px';
                document.getElementsByClassName('drag-box')[0].style.width = 0 + 'px';
                document.getElementsByClassName('drag_text')[0].classList.remove("red-bg");
                document.getElementsByClassName('drag_text')[0].classList.add("gray-bg");
                this.confirmWords = '按住滑块滑动，拖至最右边'
            }
        },
        init() {
            this.$nextTick(() => {
                document.getElementsByClassName('handler')[0].style.left = 0 + 'px';
                document.getElementsByClassName('drag-box')[0].style.width = 0 + 'px';
                document.getElementsByClassName('drag_text')[0].style.color = '#A6A6A6';
                document.getElementsByClassName('drag_text')[0].classList.remove("red-bg");
                document.getElementsByClassName('drag_text')[0].classList.add("gray-bg");
                this.confirmWords = '按住滑块滑动，拖至最右边'
            })
        },


        //手机端事件
        touchStartFn: function(e) {
            if (!this.confirmSuccess) {
                e.preventDefault && e.preventDefault(); //阻止文字选中等 浏览器默认事件
                this.mouseMoveState = true;
                console.log('手机端', e)
                this.beginClientX = e.touches[0].clientX;
                this.$emit("mouseDown");
                if (window.addEventListener) {
                    document.getElementsByTagName('html')[0].addEventListener('touchmove', this.touchMoveFn);
                    document.getElementsByTagName('html')[0].addEventListener('touchend', this.touchEndFn);
                    console.log('手机端', this.mouseMoveState)
                } else {
                    document.getElementsByTagName('html')[0].addEventListener('touchend', () => {});
                }
            }
        },
        //touchmove事件
        touchMoveFn(e) {
            console.log('手机端', this.mouseMoveState)
            if (this.mouseMoveState) {
                let width = e.touches[0].clientX - this.beginClientX;
                if (width > 0 && width <= this.maxWidth) {
                    document.getElementsByClassName('handler')[0].style.left = width + 'px';
                    document.getElementsByClassName('drag-box')[0].style.width = (width + this.$refs.moveDiv.clientWidth) + 'px';
                    document.getElementsByClassName('drag_text')[0].classList.remove("red-bg");
                    document.getElementsByClassName('drag_text')[0].classList.remove("gray-bg");
                    this.confirmWords = ''
                } else if (width > this.maxWidth) {
                    this.successFunction1();
                } else {
                    this.confirmWords = '按住滑块滑动，拖至最右边'
                }
            }
        },
        //touchstart事件
        touchEndFn(e) {
            this.mouseMoveState = false;
            const width = e.touches[0].clientX - this.beginClientX;
            if (width < this.maxWidth) {
                document.getElementsByClassName('handler')[0].style.left = 0 + 'px';
                document.getElementsByClassName('drag-box')[0].style.width = 0 + 'px';
                document.getElementsByClassName('drag_text')[0].classList.remove("red-bg");
                document.getElementsByClassName('drag_text')[0].classList.add("gray-bg");
                this.confirmWords = '按住滑块滑动，拖至最右边'
            }
        },
        successFunction1() {
            this.confirmSuccess = true;
            this.confirmWords = '验证通过';
            if (window.addEventListener) {
                document.getElementsByTagName('html')[0].removeEventListener('touchmove', this.touchMoveFn);
                document.getElementsByTagName('html')[0].removeEventListener('touchend', this.touchEndFn);
            } else {
                document.getElementsByTagName('html')[0].removeEventListener('touchend', () => {});
            }
            document.getElementsByClassName('drag_text')[0].style.color = '#fff';
            document.getElementsByClassName('drag_text')[0].classList.remove("gray-bg");
            document.getElementsByClassName('drag_text')[0].classList.add("red-bg");
            document.getElementsByClassName('handler')[0].style.left = this.maxWidth + 'px';
            document.getElementsByClassName('drag-box')[0].style.width = this.$refs.dragDiv.clientWidth + 'px';
            this.$emit("success", this.confirmSuccess);
        },
    },
    mounted() {
        this.maxWidth = this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth;
    }
}
</script>
<style scoped lang="less">
.drag {
    position: relative;
    border-radius: 168px;
    background: #E5E5E5;
    box-shadow: inset 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    // overflow: hidden;
}

.handler {
    width: 88px;
    height: 42px;
    border: 1px solid #E5E5E5;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
    border-radius: 166px;
    line-height: 42px;
    background-color: #fff;
    color: #FE2948;
    cursor: move;
}

.drag_bg {
    background-color: #FE2948;
    height: 40px;
    width: 0;
    width: 100%;
    border-radius: 168px 0 0 168px;
}

.drag-box {
    width: 0;
    height: 40px;
    border-radius: 168px;
    overflow: hidden;
}

.drag_text {
    position: absolute;
    top: 0;
    width: 100%;
    text-align: center;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    -o-user-select: none;
    -ms-user-select: none;
    color: #A6A6A6;
    font-size: 16px;
    border-radius: 168px;
}

.gray-bg {
    background: linear-gradient(-45deg, #E5E5E5 50%, rgba(255, 255, 255, .5) 60%, #E5E5E5 70%);
    background-size: 600% 100%;
    animation: shine 15s linear infinite;
}

.red-bg {
    background: linear-gradient(-45deg, #FE2948 50%, rgba(255, 255, 255, .2) 60%, #FE2948 70%);
    background-size: 600% 100%;
    animation: shine 15s linear infinite;
}

@keyframes shine {
    0% {
        background-position-x: 400%;
    }

    50% {
        background-position-x: 0%;
    }

    100% {
        background-position-x: -400%;
    }
}
</style>